<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <div class="title-with-button">
          <div class="title-col">
            <h1 class="title" v-if="!galleriesById[galleryId]">Gallery {{galleryId}}</h1>
            <h1 class="title" v-if="galleriesById[galleryId]">{{name}}</h1>
          </div>
          <div class="button-col">
            <a v-bind:href="'/api/galleries/' + galleryId" class="icon-only-button">
              <i class="im im-download" style="margin-top: 6px;"></i>
            </a>
            <button class="icon-only-button" v-on:click="() => this.showConfig = true" v-if="galleriesById[galleryId] && galleriesById[galleryId].userID == user.id">
              <i class="im im-gear" style="margin-top: 6px;"></i>
            </button>
          </div>
        </div>
        <div class="columns is-multiline" v-if="galleriesById[galleryId]">
          <div
            class="column is-3"
            v-for="imageId in galleriesById[galleryId].imageIds"
            :key="imageId"
          >
            <ImageCard v-bind:imageId="imageId" addable="true" />
          </div>
        </div>
      </div>
      <div class="column is-2" v-if="false">
        <div class="columns">
          <div class="column">
            <button class="icon-only-button" v-on:click="() => this.showConfig = false">
              <i class="im im-arrow-right" style="margin-top: 6px;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" v-bind:class="{'is-active': showConfig}">
      <div class="modal-background"></div>
      <div class="modal-card" v-if="galleriesById[galleryId]">
        <header class="modal-card-head">
          <p class="modal-card-title">Edit gallery</p>
          <button class="delete" aria-label="close" v-on:click="() => this.showConfig = false"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input class="input" type="text" placeholder="Gallery name" v-model="name">
            </div>
          </div>
          <div class="field">
            <label class="label">Public</label>
            <div class="control">
              <input type="checkbox" v-model="isPublic">
            </div>
          </div>
          <div class="field" v-if="isPublic">
            <label class="label">Password protected</label>
            <div class="control">
              <input type="checkbox" v-model="publicPW">
            </div>
          </div>
          <div class="field" v-if="isPublic && publicPW">
            <label class="label">Password</label>
            <div class="control">
              <input class="input" type="password" placeholder="Password" v-model="password">
            </div>
          </div>
          <button class="button is-danger" v-on:click="prepareDeleteGallery" v-if="!showDelete">
            Delete gallery
          </button>
          <div class="box" v-if="showDelete">
            <h5 class="is-title is-5">Really delete this gallery?</h5>
            <div class="field">
              <label class="label">Delete images</label>
              <div class="control">
                <input type="checkbox" v-model="deleteImages">
              </div>
          </div>
            <button class="button is-danger" v-on:click="deleteGallery({galleryId: galleryId, deleteImages: deleteImages})">
              Yes, delete gallery!
            </button>
          </div>
        </section>
        <footer class="modal-card-foot modal-card-foot-button-right">
            <button class="button" v-on:click="() => this.showConfig = false">Cancel</button>
            <button class="button is-success" v-on:click="updateGallery(galleryId)">Save changes</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCard from "../components/ImageCard.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    ImageCard
  },
  data() {
    return {
      galleryId: 0,
      showConfig: false,
      passwordRepeat: "",
      showDelete: false,
      deleteImages: false,
    };
  },
  computed: {
    name: {
      get () {
        return this.galleriesById[this.galleryId].name
      },
      set (value) {
        this.$store.commit('galleryNameChanged', {galleryId: this.galleryId, newName: value})
      }
    },
    isPublic: {
      get () {
        return this.galleriesById[this.galleryId].public
      },
      set (value) {
        this.$store.commit('galleryPublicChanged', {galleryId: this.galleryId, isPublic: value})
      }
    },
    publicPW: {
      get () {
        return this.galleriesById[this.galleryId].publicPW
      },
      set (value) {
        this.$store.commit('galleryPublicPWChanged', {galleryId: this.galleryId, publicPW: value})
      }
    },
    password: {
      get () {
        return this.galleriesById[this.galleryId].password
      },
      set (value) {
        this.$store.commit('galleryPasswordChanged', {galleryId: this.galleryId, password: value})
      }
    },
    ...mapState(["galleriesById", "user"]),
  },
  created() {
    this.galleryId = this.$route.params.id;
    if (!this.galleriesById[this.galleryId]) {
      this.getGallery(parseInt(this.galleryId));
    }
  },
  watch: {
    $route: {
      handler: function(to, from) {
        console.log("gallery with id", to);
      }
    }
  },
  methods: {
    ...mapActions(["getGalleries", "updateGallery", "getGallery", "deleteGallery"]),
    prepareDeleteGallery() {
      this.showDelete = true;
    }
  }
};
</script>